<mat-nav-list *ngIf="data && data.list">
  <a
    *ngFor="let listItem of data.list"
    mat-list-item
    (click)="listItem.onClick.next(data.data); this.close()"
  >
    <span mat-line>{{listItem.text}}</span>
    <span mat-line>{{listItem.subText}}</span>
  </a>
</mat-nav-list>
